module.exports = __webpack_public_path__ + "img/ctrl-s-stub--.aa8da29e.svg";